export const isNameValid = (text) => /^[a-zA-ZñÑáéíóúÁÉÍÓÚ()\s]*$/.test(text);
export const isDescriptionValid = (text) => /^[A-Za-z0-9áéíóúÁÉÍÓÚñÑ,.;:._()/""\-¿?¡!\s]*$/.test(text);